import React, { ReactElement } from 'react';
import cx from 'classnames';

import Icon from 'utils/components/icon';
import styles from './ArticlesTagsOptionCheckIcon.module.scss';

interface IArticlesTagsOptionCheckIconProps {
  className?: string;
  iconClassName?: string;
  checked: boolean;
}

const ArticlesTagsOptionCheckIcon = ({
  className,
  iconClassName,
  checked
}: IArticlesTagsOptionCheckIconProps): ReactElement => {
  return (
    <span className={cx(checked ? styles.containerChecked : styles.container, className)}>
      {checked && <Icon className={cx(styles.icon, iconClassName)} name="check" />}
    </span>
  );
};

export default ArticlesTagsOptionCheckIcon;
